import { PayloadAction } from "@reduxjs/toolkit";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import {
  IApiResponse,
  IPrintCartonRequest,
  IPrintLORequest,
  IPrintRequest,
  IProductionPlan,
} from "model";
import { IErrorResponse } from "model/Common/IErrorResponse";
import { call, put, takeEvery } from "redux-saga/effects";
import { PrintActions } from "redux/actions";
import { PrintApiService } from "services";

function* print(action: PayloadAction<IPrintRequest>) {
  try {
    const result: IApiResponse<IProductionPlan[]> = yield call(
      PrintApiService.print,
      action.payload
    );
    if (result.succeeded) {
      yield put(PrintActions.print.success(result.data!));
      AlertHelper.showAlert("Print Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(PrintActions.print.failed(error));
    }
  } catch (error) {
    yield put(PrintActions.print.failed(error));
  }
}

function* printCartonBarcode(action: PayloadAction<IPrintCartonRequest>) {
  try {
    const result: IApiResponse<any> = yield call(
      PrintApiService.printCartonBarcode,
      action.payload
    );
    if (result.succeeded) {
      yield put(PrintActions.printCartonBarcode.success(result.data!));
      AlertHelper.showAlert("Print Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(PrintActions.printCartonBarcode.failed(error));
    }
  } catch (error) {
    yield put(PrintActions.printCartonBarcode.failed(error));
  }
}

function* printLO(action: PayloadAction<IPrintLORequest>) {
  try {
    const result: IApiResponse<any> = yield call(
      PrintApiService.printLO,
      action.payload
    );
    if (result.succeeded) {
      yield put(PrintActions.printLO.success(result.data!));
      AlertHelper.showAlert("Print Successfully", EAlertType.SUCCESS);
    } else {
      const error = result as IErrorResponse;
      yield put(PrintActions.printLO.failed(error));
    }
  } catch (error) {
    yield put(PrintActions.printLO.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(PrintActions.print.request, print);
  yield takeEvery(PrintActions.printCartonBarcode.request, printCartonBarcode);
  yield takeEvery(PrintActions.printLO.request, printLO);
}
